import React, {useCallback, useEffect} from "react";
import PropTypes, {InferProps} from "prop-types";
import {FileUploadView} from "./fileupload.view";
import {useFile} from "./fileupload.service";
import {File} from "@betrue/common/shared";

export const FileUploadPropsTypes = {
  dropZoneLabel: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
}

export interface FileUploadProps extends InferProps<typeof FileUploadPropsTypes> {
  onFileUpload: (file: File) => void
}

export const FileUpload = (props: FileUploadProps) => {

  const [file, {deleteFile, uploadFile}] = useFile<File>()

  useEffect(()=> {
    if(file){
      props.onFileUpload(file)
    }
  },[file])


  const handleFileDrop = useCallback(files => {
    console.log(files)
    uploadFile(files[0])
    // Do something with the files
  }, [])

  return (
    <FileUploadView {...props} onDrop={handleFileDrop}/>
  );
}

FileUpload.propTypes = FileUploadPropsTypes
